/**
 * Компонент бейджа для отображения статусов и меток с вариантами цветов
 */
import { ReactNode } from 'react';
import { cn } from '@/utils/cn';

interface BadgeProps {
  children: ReactNode;
  variant?: 'success' | 'warning' | 'error' | 'info' | 'secondary';
  className?: string;
  testId?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  title?: string;
}

const variants = {
  success: 'bg-shell-success-soft text-shell-success',
  warning: 'bg-shell-warning-soft text-shell-warning',
  error: 'bg-shell-danger-soft text-shell-danger',
  info: 'bg-shell-primary-soft text-shell-primary-strong',
  secondary: 'bg-shell-elevated text-shell-text',
};

export function Badge({ children, variant = 'secondary', className, testId, style, onClick, title }: BadgeProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        'badge',
        variants[variant],
        onClick && 'cursor-pointer',
        className
      )}
      style={style}
      onClick={onClick}
      title={title}
    >
      {children}
    </span>
  );
}

